'use strict';

var variables = require('./variables-1eb6495a.js');
var colorManipulator = require('./colorManipulator-abc93889.js');

const light = {
    root: {
        // These paddings and widths work together with the ones in switchBase, thumb and sizeSmall and aligns with the
        // marginLeft property of MuiFormControlLabel. Changing the values should be done with extreme care.
        padding: "10px",
        width: "60px",
        height: "40px",
    },
    switchBase: {
        padding: "11px",
        "&$disabled": {
            "& $thumb": {
                backgroundColor: variables.COLORS.GREYSCALE_100_50,
            },
        },
        "&$checked + $track": {
            opacity: 1,
        },
        "&$disabled + $track": {
            opacity: 0.12,
        },
        "&.sprout-focus-visible": {
            borderColor: "transparent",
            boxShadow: `none`,
        },
    },
    colorPrimary: {
        "&.sprout-focus-visible + $track": {
            borderColor: variables.COLORS.GREEN_PALE,
            boxShadow: `0 0 0 3px ${colorManipulator.alpha(variables.COLORS.GREEN_PALE, 0.5)}`,
        },
    },
    colorSecondary: {
        "&.sprout-focus-visible + $track": {
            borderColor: variables.COLORS.BLUE_PALE,
            boxShadow: `0 0 0 3px ${colorManipulator.alpha(variables.COLORS.BLUE_PALE, 0.5)}`,
        },
    },
    track: {
        opacity: 1,
        backgroundColor: variables.COLORS.GREYSCALE_0_15,
        borderRadius: variables.SIZES.BORDER_RADIUS,
    },
    thumb: {
        height: "16px",
        width: "16px",
        borderRadius: variables.SIZES.BORDER_RADIUS,
        backgroundColor: variables.COLORS.GREYSCALE_100,
    },
    sizeSmall: {
        height: "32px",
        width: "52px",
        padding: "8px 10px",
        "& $thumb": {
            height: "12px",
            width: "12px",
        },
        "& $switchBase": {
            padding: "9px 11px",
        },
    },
};

var MuiSwitch = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiSwitch = MuiSwitch;
exports.light = light;
